import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import customerProductsApi from "../shared/api/customerProductsApi";
import { CustomerSearchAndBuyState, ProductsQuery, ProductsQueryParameter } from "../shared/models/customerSearchAndBuyModels";

export const getProducts = createAsyncThunk(
  "customerSearchAndBuy/getProducts",
  async (query: ProductsQuery) => {
    return customerProductsApi.getProducts(query);
  }
);

const initialState: CustomerSearchAndBuyState = {
  query: {
    search: undefined,
    sortBy: ProductsQueryParameter.name,
    sortDesc: false,
    pageNo: 1,
    pageSize: 8
  },
  products: undefined,
  product: undefined,
  loading: false,
  success: undefined,
  error: undefined
};

const customerSearchAndBuySlice = createSlice({
  name: "customerSearchAndBuy",
  initialState: initialState,
  reducers: {
    changeQuery: (state, action) => {
      state.query = action.payload;
    },
    selectProduct: (state, action) => {
      state.product = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProducts.fulfilled, (state, { payload }) => {
        state.products = payload;
        state.loading = false;
      })
      .addCase(getProducts.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });
  }
});

export const {
  changeQuery,
  selectProduct,
  setSuccess,
  setError
} = customerSearchAndBuySlice.actions;

export default customerSearchAndBuySlice.reducer;